import { useContext } from "react"

import { TranslationsContext } from "./TranslationsProvider"

export const useGetTranslationsContext = () => {
  const context = useContext(TranslationsContext)
  if (!context) {
    throw new Error(
      "useGetTranslationsContext must be used within a TranslationsProvider"
    )
  }
  return context
}
